import { Component, inject } from "@angular/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { GlobalLoadingService } from "@core/loading/global-loading.service";

@Component({
  selector: "app-global-loader",
  imports: [LottieComponent],
  standalone: true,
  templateUrl: "./global-loader.component.html",
  styleUrl: "./global-loader.component.scss",
})
export class GlobalLoaderComponent {
  protected readonly globalLoading = inject(GlobalLoadingService);
  lottieOptions: AnimationOptions = {
    path: "assets/lottie/vm_loading_lightmode.json",
    loop: true,
    autoplay: true,
  };
}
